module.exports = __webpack_public_path__ + "img/13.d29f15d4.png";